import util from '@/utils/util'

export default {
	install (Vue) {
		Vue.prototype.$util = util
	}
}



// WEBPACK FOOTER //
// ./src/plugins/inject.js